import React from 'react';

export enum Partner {
    NationBuilder = 'NationBuilder',
    Packlane = 'Packlane',
    Square = 'Square',
    Squarespace = 'Squarespace',
}

interface PartnerContext {
    partner?: Partner;
}

export default React.createContext<PartnerContext>({});
